// @flow

// polyfills up top
import './polyfills'

// import sass for webpack build process
import '../scss/styles.scss'

import 'what-input'

// TODO: chrome has lazyloading build in @see https://scotch.io/bar-talk/native-lazy-loading-launched-on-chrome-76
// eslint-disable-next-line
import 'lazysizes'
import Mailcheck from 'mailcheck'
import Vue from 'vue'

// sentry error tracking after loading vue
import errorTrackerInit from '@/utils/error-tracker'
errorTrackerInit(Vue)

// blade ga link tracker
import { trackLinkInit, trackEvent } from '@/utils/analytics'
trackLinkInit()
// kinda hacky, want to remove, used on subscription-thanks.blade.php
window.fbTrackEvent = trackEvent

import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import validationRules from '@/utils/validation-rules'
import { fbAnnouncement } from '@/common/announcement'

// vue pages mounted by JSX (old way to mound by id)

/* TODO: we probably do not need this anymore, audit usage, then remove */
/* eslint-disable-next-line */
import Modernizr from '@/.modernizrrc'

// pinia store
import { PiniaVuePlugin } from 'pinia'
import { pinia } from '@/stores'
import { useUserAuthStore } from '@/stores/user-auth'

Vue.use(PiniaVuePlugin)

// dynamic SPA routing
import createSpaRoutes from './router'
import RouterView from './components/router/router-view.vue'

window.pinia = pinia
window.Vue = Vue
window.Mailcheck = Mailcheck

// add vee-validator for form validation
Vue.use(VueResource)
import { Validator } from 'vee-validate'
validationRules(Validator)
Vue.use(VeeValidate, { events: 'blur' })

// add csrf token to vue requests
Vue.http.interceptors.push((request, next) => {
  const userAuthStore = useUserAuthStore()
  request.headers.set('X-CSRF-TOKEN', userAuthStore.csrfToken)
  next()
})

/**
 * Components for use in Laravel Blade template rendering
 * and included in main app module
 */
import { commonComponentsInit } from '@/views/common-components'

commonComponentsInit()

// code split components
import subscriptionCodeSplit from '@/views/subscriptions'
import accountCodeSplit from '@/views/users'
import discussionsCodeSplit from '@/views/discussions'
import searchCodeSplit from '@/views/search'
import miscCodeSplit from '@/views/misc-ctas'

subscriptionCodeSplit()
accountCodeSplit()
discussionsCodeSplit()
searchCodeSplit()
miscCodeSplit()

// SPA routes (mounted on id="app")
const router = createSpaRoutes()
Vue.router = router

// not a code split, but init inside of id="header" and needs router / pinia
import modalsInit from '@/views/modals'

modalsInit({
  pinia,
  router,
})

const SPA = new Vue({
  name: 'SinglePageApp',
  pinia,
  router,
  ...RouterView,
})

if (document.getElementById('app') !== null) {
  SPA.$mount('#app')
}

// non SPA routes (new - 2019/08)
// use id="vue" or class="vue" in the blade template and this will pick up on any components
// registered above and ideally avoid "vue not loaded"
const vueEl = document.querySelector('#vue')

if (vueEl) {
  new Vue({
    name: vueEl.dataset.app || null,
    pinia,
    router,
    el: vueEl,
  })
}
const vueClasses = document.querySelectorAll('.vue')
if (vueClasses.length) {
  for (let i = 0; i < vueClasses.length; ++i) {
    const el = vueClasses[i]

    new Vue({
      name: el.dataset.app || null,
      pinia,
      router,
      el: vueClasses[i],
    })
  }
}
// end non-SPA routes

/**
 * Header
 */
import { Header } from '@/common/header-init'
const header = new Header()
header.init()

/**
 * Initialize non-vue items
 */
import calendarInit from '@/views/calendar'
import { scrollToInit } from '@/utils/scroll-to'
import singleClickSubmit from '@/utils/blade-submit'
import { resizePointerType } from '@/utils/device'
import { userStoresInit } from '@/utils/user-stores'

document.addEventListener('DOMContentLoaded', () => {
  // Announcement Bar
  if (document.getElementById('announcement') !== null) {
    fbAnnouncement()
  }

  // anchor scrolling
  scrollToInit()

  // disable double submits from blade forms
  singleClickSubmit()

  // load functionality for calendar.blade.php, it isn't vue :(
  calendarInit()

  // change device on resize, must be invoked after pinia
  resizePointerType()

  // lots of stuff going on during app boot, so allwo XHR to
  // init state happen after DOM renders
  Vue.nextTick(() => {
    userStoresInit()
  })
})
